import { customStyles } from '../../styles/customStyles';
import { useState } from 'react';

const AnalysisSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Ценовую стратегию",
      items: [
        "текущую цену",
        "историю изменения цен",
        "глубину и частоту скидок",
        "ценовое позиционирование в нише"
      ]
    },
    {
      title: "Социальное доказательство",
      items: [
        "количество отзывов",
        "скорость прироста отзывов",
        "рейтинг и его динамику",
        "повторяющиеся жалобы"
      ]
    },
    {
      title: "Текстовую структуру",
      items: [
        "заголовки",
        "подзаголовки",
        "ключевые УТП",
        "повторяющиеся смысловые паттерны"
      ]
    },
    {
      title: "Фото-воронку",
      items: [
        "количество слайдов",
        "логику их последовательности",
        "наличие болевых блоков",
        "сравнительные таблицы"
      ]
    },
    {
      title: "Визуальные триггеры",
      items: [
        "цветовые решения",
        "контраст",
        "наличие лица / модели",
        "выделение УТП"
      ]
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section id="analysis" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="max-w-md mx-auto transform -rotate-2 relative p-8" style={{ ...customStyles.paperCard, backgroundColor: '#fff' }}>
            <div className="absolute left-0 top-0 bottom-0 w-4 border-r-2 border-dashed border-[#1F1F1F]/20"></div>
            <div className="pl-6">
              <div className="flex justify-between items-start mb-8 border-b border-[#1F1F1F]/10 pb-4">
                <h3 className="font-sans text-sm font-semibold">Trippy анализирует:</h3>
                <div className="flex items-center gap-2">
                  <button 
                    onClick={prevSlide}
                    className="w-8 h-8 rounded-full border border-[#1F1F1F]/20 flex items-center justify-center hover:bg-[#b7eb6f] hover:border-[#b7eb6f] transition-colors"
                  >
                    <i className="ph ph-caret-left text-sm"></i>
                  </button>
                  <button 
                    onClick={nextSlide}
                    className="w-8 h-8 rounded-full border border-[#1F1F1F]/20 flex items-center justify-center hover:bg-[#b7eb6f] hover:border-[#b7eb6f] transition-colors"
                  >
                    <i className="ph ph-caret-right text-sm"></i>
                  </button>
                </div>
              </div>
              
              <h4 className="font-sans text-lg font-bold mb-4">{slides[currentSlide].title}</h4>
              
              <ul className="space-y-3 font-sans text-sm">
                {slides[currentSlide].items.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ph-fill ph-check-circle text-[#b7eb6f] mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              
              <div className="mt-8 p-4 bg-[#F4F1EA] rounded border border-[#1F1F1F]/5 text-xs leading-relaxed">
                Trippy не просто "смотрит карточку". Trippy разбирает её как систему продаж.
              </div>
            </div>
          </div>
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#b7eb6f] rounded-full flex items-center justify-center shadow-lg">
            <span className="font-typewriter text-xs text-center">Data<br />Inside</span>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="w-12 h-1 bg-[#b7eb6f] mb-6"></div>
          <h2 className="font-serif-display text-5xl lg:text-6xl mb-6">Анализируйте конкурентов <span className="italic text-[#1F1F1F]/60">глубже,</span> чем они сами</h2>
          <p className="font-sans text-lg opacity-80 mb-8 max-w-lg">
            Trippy анализирует их карточки и автоматически создаёт для вас более сильную воронку:
          </p>
          <div className="flex flex-wrap gap-2 mb-8">
            <span className="px-3 py-1 border border-[#1F1F1F] rounded-full text-xs font-sans hover:bg-[#1F1F1F] hover:text-white transition-colors cursor-default">• усиливает слабые места</span>
            <span className="px-3 py-1 border border-[#1F1F1F] rounded-full text-xs font-sans hover:bg-[#1F1F1F] hover:text-white transition-colors cursor-default">• закрывает реальные боли из отзывов</span>
            <span className="px-3 py-1 border border-[#1F1F1F] rounded-full text-xs font-sans hover:bg-[#1F1F1F] hover:text-white transition-colors cursor-default">• выстраивает структуру под рост конверсии</span>
            <span className="px-3 py-1 border border-[#1F1F1F] rounded-full text-xs font-sans hover:bg-[#1F1F1F] hover:text-white transition-colors cursor-default">• предлагает стили под каждый этап воронки</span>
          </div>
          <a href="#" className="inline-flex items-center gap-2 text-[#b7eb6f] font-typewriter uppercase tracking-widest text-sm hover:gap-4 transition-all group">
            Проанализировать конкурентов
            <i className="ph ph-arrow-right text-lg group-hover:text-[#1F1F1F]"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AnalysisSection;
